import React from 'react';
import { Button } from './ui/button';
import { Building2, Calculator, Users, Briefcase, Shield, Home, Phone, Megaphone, Coffee } from 'lucide-react';

const EcosystemServices = ({ onOpenModal }) => {
  const services = [
    {
      icon: Home,
      title: 'Office Fit-Out',
      description: 'Find vetted and pre-qualified contractors for your office fit-out requirements. Better outcomes in terms of cost, quality, and timelines with optional project management services.',
      link: '#fitout',
    },
    {
      icon: Briefcase,
      title: 'Banking Assistance',
      description: 'Gain access to a comprehensive range of financial products and services tailored to meet unique requirements. Advanced solutions for optimizing operations and reducing expenses.',
      link: '#banking',
    },
    {
      icon: Calculator,
      title: 'Tax & Accounting',
      description: 'The in-house team of experts offer unbiased advice and guidance on Books of Accounts, Auditing, VAT Registration, Corporate Tax Filing Services, and more.',
      link: '#tax',
    },
    {
      icon: Coffee,
      title: 'Business Hub',
      description: 'State-of-the-art coworking, conference, and meeting room facilities. Access our fully serviced business centre in the heart of UAE.',
      link: '#hub',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            The <span className="text-[#6B1B4D]">Firmzy</span> Ecosystem
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Business setup is just the first step towards success. Our full suite of services ensures you have all the tools for your company's growth.
          </p>
          <p className="text-lg text-gray-600 mt-4">
            We'll guide you through each step, from tax and accounting services to recruitment assistance, legal support, co-working spaces, and more.
          </p>
          <Button 
            className="mt-8 bg-[#DC143C] hover:bg-[#DC143C]/90 text-white px-8 py-6 text-lg"
            size="lg"
            onClick={onOpenModal}
          >
            Enquire Now
          </Button>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {services.map((service, idx) => {
            const IconComponent = service.icon;
            return (
              <div
                key={idx}
                className="group bg-gradient-to-br from-white to-gray-50 rounded-xl p-8 border border-gray-200 hover:border-[#6B1B4D] transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-20 h-20 bg-gradient-to-br from-[#6B1B4D] to-[#DC143C] rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg">
                  <IconComponent className="text-white" size={36} />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-4 group-hover:text-[#6B1B4D] transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed mb-6">
                  {service.description}
                </p>
                <a 
                  href={service.link}
                  className="text-[#DC143C] font-medium text-sm hover:underline inline-flex items-center"
                >
                  Learn More →
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EcosystemServices;